import { API } from "../config";

// Fires to window.dataLayer (GA4 / GTM), Meta Pixel (fbq), and our own
// backend event store. Connect GA / Meta later by adding their snippets
// to public/index.html — no code changes needed here.
export const trackEvent = (event, params = {}) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    if (typeof window.fbq === "function") window.fbq("trackCustom", event, params);
    if (typeof window.gtag === "function") window.gtag("event", event, params);
  } catch (e) {
    /* tracking must never break UX */
  }
  fetch(`${API}/events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ event, params }),
  }).catch(() => {});
};

// Meta standard Lead event — fires ONLY after the server confirms the inquiry saved.
export const trackLead = (params = {}) => {
  const eventID = `lead_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
  try {
    if (typeof window.fbq === "function") window.fbq("track", "Lead", params, { eventID });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "lead", eventID, ...params });
  } catch (e) {
    /* tracking must never break UX */
  }
};

// UTM + click-id attribution, captured once on landing and reused for the lead.
export const getAttribution = () => {
  try {
    if (!sessionStorage.getItem("cc_attr")) {
      const p = new URLSearchParams(window.location.search);
      const attr = { page_url: window.location.href.split("?")[0] };
      ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"].forEach(
        (k) => {
          const v = p.get(k);
          if (v) attr[k] = v;
        }
      );
      sessionStorage.setItem("cc_attr", JSON.stringify(attr));
    }
    return JSON.parse(sessionStorage.getItem("cc_attr")) || {};
  } catch {
    return {};
  }
};
